module.exports = __webpack_public_path__ + "img/speaker-PatrickKluivert-imgs.f018a721.png";